module.exports = __webpack_public_path__ + "img/img_esti.c354bee7.jpg";